import i18n from '@/locale/i18n'

import mobileDevice from '@/page/mobileDevice/index'
export default [
	{
		path: '/mobileDevice',
		component: mobileDevice,
		meta: { title: i18n.t('mobileDevice.title') }
	},
]



// WEBPACK FOOTER //
// ./src/router/mobileDevice/index.js